import { Page as RPPage } from 'react-pdf';
import { VariableSizeList } from 'react-window';
import Styles from '../assets/style.scss';
import React from 'react';
import { findMessage } from '../../BCIntl';
import IPDFViewerPageProps from '../entities/PDFViewer/IPDFViewerPageProps';
import IPDFViewerPageItemProps from '../entities/PDFViewer/IPDFViewerPageItemProps';
import type { PDFPageProxy } from 'pdfjs-dist';
import { useOverlayScrollbars } from 'overlayscrollbars-react';

const Page = (props: IPDFViewerPageItemProps) => {
	return (
		<div
			key={props.index + 1}
			style={props.style}
		>
			<RPPage
				pageNumber={props.index + 1}
				className={Styles.pdfPage}
				scale={props.data.scale}
				loading={findMessage.get('100127')}
				noData={findMessage.get('100705')}
			>
				<span className={Styles.pdfPageNumber}>
					{props.index + 1} / {props.data.numPages}
				</span>
			</RPPage>
		</div>
	);
};

const PDFViewerPage = (props: IPDFViewerPageProps) => {
	const [pageHeightList, setPageHeightList] = React.useState<Array<PDFPageProxy>>(null);
	const listRef = React.useRef(null);
	const rootRef = React.useRef(null);
	const outerRef = React.useRef(null);

	const [initialize] = useOverlayScrollbars({ defer: true });

	React.useEffect(() => {
		(async () => {
			if (props.pdf) {
				const pagesPromise: Array<Promise<PDFPageProxy>> = new Array(props.pdf.numPages)
					.fill(undefined)
					.map((_, index) => props.pdf.getPage(index + 1));

				const pages = await Promise.all(pagesPromise);

				setPageHeightList(pages);
			}
		})();
	}, [props.pdf]);

	React.useEffect(() => {
		const { current: root } = rootRef;
		const { current: outer } = outerRef;

		if (root && outer) {
			initialize({
				target: root,
				elements: {
					viewport: outer
				}
			});
		}
	}, [initialize, pageHeightList]);

	React.useEffect(() => {
		listRef.current?.resetAfterIndex(0);
	}, [props.scale, props.dimensions.height]);

	const itemSize = React.useCallback(
		(index: number) =>
			pageHeightList[index].getViewport({
				scale: props.scale / 100
			}).height,
		[pageHeightList, props.dimensions.height, props.scale]
	);

	const itemKey = React.useCallback((index: number) => index + '_' + itemSize(index), [itemSize]);

	return pageHeightList ? (
		<div
			data-overlayscrollbars=""
			ref={rootRef}
		>
			<VariableSizeList
				ref={listRef}
				outerRef={outerRef}
				{...props.dimensions}
				itemCount={props.pdf.numPages}
				itemSize={itemSize}
				itemKey={itemKey}
				itemData={{
					scale: props.scale / 100,
					numPages: props.pdf.numPages
				}}
			>
				{Page}
			</VariableSizeList>
		</div>
	) : null;
};

export default PDFViewerPage;
